import script from "./AnimatedLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./AnimatedLogo.vue?vue&type=script&setup=true&lang=js"

import "./AnimatedLogo.vue?vue&type=style&index=0&id=97d0e2a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97d0e2a8"]])

export default __exports__